module.exports = __webpack_public_path__ + "img/57.38b846f3.jpg";